__turbopack_context__.v({
  "badgeWithDistrib": "CurrencyBadge-module-scss-module__ryBsSW__badgeWithDistrib",
});
